import React, { Suspense } from "react";
import "./App.scss";
import { BrowserRouter as Router } from "react-router-dom";
import {
  StylesProvider,
  ThemeProvider,
  createStyles,
} from "@material-ui/styles";
import { SnackbarProvider } from "notistack";
import AppToolbar from "./components/AppToolbar";
import User from "./components/User";
import AppTheme from "./AppTheme";
import LoadingBar from "react-redux-loading-bar";
import Store from "./Store";
import { Provider } from "react-redux";
import Company from "./context/CompanyContext";
import AppRoutes from "./AppRoutes";
import IdleTimer from "react-idle-timer";
import InactivityDialog from "./components/InactivityDialog";
import AppIntercepter from "./AppIntercepter";
import { makeStyles, Theme } from "@material-ui/core";
import * as configcat from "configcat-js";

//Set up ConfigCat Feature Flagging
const configCatClient = configcat.createClient(
  process.env.REACT_APP_CONFIG_CAT_KEY as string
);

const App: React.FC = () => {
  const inactivityTime = 20 * 1000 * 60;
  const idleTimer = null;
  const [showInactivity, setShowInactivity] = React.useState(false);
  const classes = useStyles();

  function onIdle() {
    setShowInactivity(true);
  }

  return (
    <ThemeProvider theme={AppTheme}>
      <StylesProvider injectFirst>
        <SnackbarProvider
          classes={{ variantInfo: classes.info }}
          maxSnack={3}
          autoHideDuration={3000}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
        >
          <AppIntercepter />
          <Provider store={Store}>
            <LoadingBar showFastActions className="loading" />
            <IdleTimer
              ref={idleTimer}
              element={document}
              onIdle={onIdle}
              debounce={250}
              timeout={inactivityTime}
            />
            <div className="App">
              <Router>
                <Company>
                  <User>
                    <AppToolbar />
                    <Suspense fallback={<div />}>
                      <AppRoutes />
                    </Suspense>
                    <InactivityDialog
                      open={showInactivity}
                      onClose={() => setShowInactivity(false)}
                    />
                  </User>
                </Company>
              </Router>
            </div>
          </Provider>
        </SnackbarProvider>
      </StylesProvider>
    </ThemeProvider>
  );
};

export default App;
export { configCatClient };

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    info: {
      background: "#1ea3f8",
    },
  })
);
